import React from 'react';
import { getInitials } from '../utils/helpers';

function MemberAvatar({ photo, name, size = 'md' }) {
  const sizeClass = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-16 h-16 text-xl',
    xl: 'w-24 h-24 text-3xl',
  }[size] || 'w-10 h-10 text-sm';

  if (photo) {
    return (
      <img
        src={`${photo}`}
        alt={name}
        className={`${sizeClass} rounded-full object-cover flex-shrink-0`}
        onError={e => { e.target.onerror = null; e.target.src = ''; e.target.style.display = 'none'; e.target.nextSibling?.style?.removeProperty('display'); }}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full flex items-center justify-center font-bold flex-shrink-0`}
      style={{ background: 'rgba(0,255,240,0.12)', color: 'var(--aqua)', border: '1px solid rgba(0,255,240,0.2)' }}
    >
      {getInitials(name)}
    </div>
  );
}

export default MemberAvatar;
